/* eslint-disable react/prop-types */
import React from 'react';
import { any } from 'prop-types';
import KiloMobileFooter from '../Business/KiloMobileFooter';
import BusinessFooter2024 from '../Footer/BusinessFooter2024.jsx';
import BusinessHeader2024 from '../Header/BusinessHeader2024.jsx';
import Seo from '../SEO/Seo';
import '../../styles/fonts/brown.css';

const BusinessLayout2024 = (props) => {
  const {
    canonicalURL,
    children,
    customDescription,
    customImage,
    customImageAltText,
    customImageTwitter,
    customTitle,
    metaTitle,
    location,
  } = props;

  return (
    <div>
      <Seo
        canonicalURL={canonicalURL ?? ''}
        customDescription={customDescription ?? ''}
        customImage={customImage ?? ''}
        customImageAltText={customImageAltText ?? ''}
        customImageTwitter={customImageTwitter ?? ''}
        metaTitle={metaTitle ?? ''}
        location={location ?? ''}
      >
        <title>{customTitle ?? ''}</title>
      </Seo>

      <BusinessHeader2024 />

      {children}

      <BusinessFooter2024 className="hidden md:block" />
      <KiloMobileFooter className="md:hidden" />
    </div>
  );
};

BusinessLayout2024.propTypes = {
  children: any,
};

export default BusinessLayout2024;
